import { makeStyles } from "tss-react/mui";

import { styled, Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    card: {
        width: 100,
        float: "right",
        border: "0.6px dashed black",
    },
    content: {
        height: 50,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-evenly",
        paddingTop: theme.spacing(4),
    },
    button: {
        color: theme.palette.emteria.primary,
        height: "30.36px",
        fontSize: "10.71px",
        lineHeight: "14px",
    },
    sectionHeader: {
        fontSize: 18,
        lineHeight: "23.94px",
        paddingBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
        margin: 0,
        flexShrink: 0,
    },
    sectionContainer: {
        padding: theme.spacing(4),
        paddingTop: 0,
        paddingBottom: theme.spacing(8),
    },
    commandParametersLabel: {
        position: "relative",
        top: theme.spacing(5),
    },
    input: {
        height: 40,
        flex: 0.7,
    },
    hints: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: theme.spacing(2),
        paddingTop: theme.spacing(2),
    },
    switchButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },

    select: {
        "& .MuiInputBase-root": {
            height: "40px",
        },
    },
}));

export const InputItemContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    paddingTop: theme.spacing(5),
    flexShrink: 0,
}));
